import React from "react";
import { getRequiredTailwindColorHexByName } from "@/utils/color-util";

const CUBE_NETWORK_ICON_FILL = getRequiredTailwindColorHexByName("mint-green");

export function CubeNetworkIcon({ vectorEffect, ...rest }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="31"
      viewBox="0 0 28 31"
      fill="none"
      {...rest}
    >
      <g clipPath="url(#clip0_8107_76073)">
        <path
          d="M13.6406 6.25C15.0213 6.25 16.1406 5.13071 16.1406 3.75C16.1406 2.36929 15.0213 1.25 13.6406 1.25C12.2599 1.25 11.1406 2.36929 11.1406 3.75C11.1406 5.13071 12.2599 6.25 13.6406 6.25Z"
          fill={CUBE_NETWORK_ICON_FILL}
          stroke="#33514B"
          strokeWidth="1.5"
          vectorEffect={vectorEffect}
        />
        <path
          d="M13.6406 18.25C15.0213 18.25 16.1406 17.1307 16.1406 15.75C16.1406 14.3693 15.0213 13.25 13.6406 13.25C12.2599 13.25 11.1406 14.3693 11.1406 15.75C11.1406 17.1307 12.2599 18.25 13.6406 18.25Z"
          fill={CUBE_NETWORK_ICON_FILL}
          stroke="#33514B"
          strokeWidth="1.5"
          vectorEffect={vectorEffect}
        />
        <path
          d="M13.6406 30.25C15.0213 30.25 16.1406 29.1307 16.1406 27.75C16.1406 26.3693 15.0213 25.25 13.6406 25.25C12.2599 25.25 11.1406 26.3693 11.1406 27.75C11.1406 29.1307 12.2599 30.25 13.6406 30.25Z"
          fill={CUBE_NETWORK_ICON_FILL}
          stroke="#33514B"
          strokeWidth="1.5"
          vectorEffect={vectorEffect}
        />
        <path
          d="M24.0312 24.25C25.412 24.25 26.5312 23.1307 26.5312 21.75C26.5312 20.3693 25.412 19.25 24.0312 19.25C22.6505 19.25 21.5312 20.3693 21.5312 21.75C21.5312 23.1307 22.6505 24.25 24.0312 24.25Z"
          fill={CUBE_NETWORK_ICON_FILL}
          stroke="#33514B"
          strokeWidth="1.5"
          vectorEffect={vectorEffect}
        />
        <path
          d="M24.0312 12.25C25.412 12.25 26.5312 11.1307 26.5312 9.75C26.5312 8.36929 25.412 7.25 24.0312 7.25C22.6505 7.25 21.5312 8.36929 21.5312 9.75C21.5312 11.1307 22.6505 12.25 24.0312 12.25Z"
          fill={CUBE_NETWORK_ICON_FILL}
          stroke="#33514B"
          strokeWidth="1.5"
          vectorEffect={vectorEffect}
        />
        <path
          d="M3.25 12.25C4.63071 12.25 5.75 11.1307 5.75 9.75C5.75 8.36929 4.63071 7.25 3.25 7.25C1.86929 7.25 0.75 8.36929 0.75 9.75C0.75 11.1307 1.86929 12.25 3.25 12.25Z"
          fill={CUBE_NETWORK_ICON_FILL}
          stroke="#33514B"
          strokeWidth="1.5"
          vectorEffect={vectorEffect}
        />
        <path
          d="M3.25 24.25C4.63071 24.25 5.75 23.1307 5.75 21.75C5.75 20.3693 4.63071 19.25 3.25 19.25C1.86929 19.25 0.75 20.3693 0.75 21.75C0.75 23.1307 1.86929 24.25 3.25 24.25Z"
          fill={CUBE_NETWORK_ICON_FILL}
          stroke="#33514B"
          strokeWidth="1.5"
          vectorEffect={vectorEffect}
        />
        <path
          d="M9.68094 13.46L7.21094 12.04"
          stroke="#33514B"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          vectorEffect={vectorEffect}
        />
        <path
          d="M17.6094 13.46L20.0694 12.04"
          stroke="#33514B"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          vectorEffect={vectorEffect}
        />
        <path
          d="M9.68094 6.04004L7.21094 7.46004"
          stroke="#33514B"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          vectorEffect={vectorEffect}
        />
        <path
          d="M17.6094 6.04004L20.0694 7.46004"
          stroke="#33514B"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          vectorEffect={vectorEffect}
        />
        <path
          d="M9.68094 25.46L7.21094 24.04"
          stroke="#33514B"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          vectorEffect={vectorEffect}
        />
        <path
          d="M17.6094 25.46L20.0694 24.04"
          stroke="#33514B"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          vectorEffect={vectorEffect}
        />
        <path
          d="M13.6406 20.33V23.17"
          stroke="#33514B"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          vectorEffect={vectorEffect}
        />
        <path
          d="M3.25 14.33V17.17"
          stroke="#33514B"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          vectorEffect={vectorEffect}
        />
        <path
          d="M24.0312 17.17V14.33"
          stroke="#33514B"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          vectorEffect={vectorEffect}
        />
      </g>
      <defs>
        <clipPath id="clip0_8107_76073">
          <rect
            width="27.28"
            height="30.5"
            fill="white"
            transform="translate(0 0.5)"
            vectorEffect={vectorEffect}
          />
        </clipPath>
      </defs>
    </svg>
  );
}
